import { render, staticRenderFns } from "./main-navigation.vue?vue&type=template&id=939f9404&scoped=true&"
import script from "./main-navigation.vue?vue&type=script&lang=js&"
export * from "./main-navigation.vue?vue&type=script&lang=js&"
import style0 from "./main-navigation.vue?vue&type=style&index=0&id=939f9404&scoped=true&lang=scss&"
import style1 from "./main-navigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939f9404",
  null
  
)

export default component.exports